import { ReactNode } from 'react';

import useAuthenticated from './vm';
import { Stack } from '@mui/material';
import Spinner from '../../Spinner';

interface Props {
  children: ReactNode;
}

const Authenticated = ({ children }: Props) => {
  const { isLoading } = useAuthenticated();

  if (isLoading) {
    return (
      <Stack height="100%" justifyContent="center" alignItems="center">
        <Spinner size="xLarge" />
      </Stack>
    );
  }

  return <>{children}</>;
};

export default Authenticated;
